const compRules = {
	name:  {
		presence: {
			allowEmpty: false
		}
	},
	email: {
		email: true
	}
};

export default compRules;